import styled from 'styled-components';

export const StyledEmailTemplates = styled.div`
  .Polaris-Tabs__Outer {
    & > .Polaris-Box {
      padding: 0 0 1rem;
    }
  }
`;
